import { render, staticRenderFns } from "./TemplateVars.vue?vue&type=template&id=1e1a2189&scoped=true"
import script from "./TemplateVars.vue?vue&type=script&lang=js"
export * from "./TemplateVars.vue?vue&type=script&lang=js"
import style0 from "./TemplateVars.vue?vue&type=style&index=0&id=1e1a2189&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1a2189",
  null
  
)

export default component.exports